
import Either from 'data.either'
import backend from '../backend'
import i18next from '../i18n/i18n'
import iban from 'iban'

import { fetchJson, fetchJsonWithBasicAuth, fetchJsonWithJWT, catchResponse401ResetAuthToken, parseJwt } from '../commons/utils'
import validator from 'validator'
const modulState = {

	state: () => ({
		bic: '',
		receipient: '',
		iban: '',
		betrag: 0.01,
		referenz: '',
		verwendungszweck: '',
		hinweis: '',
		undeleteTemplate: null,
		templates: []
	}),
	getters:{
		templates: state => state.templates,
		isShowLoadTemplate: state => state.templates.length,
		undeleteTemplate: state => state.undeleteTemplate,
		bic: state => state.bic,
		receipient: state => state.receipient,
		iban: state => state.iban,
		betrag: state => state.betrag,
		referenz: state => state.referenz,
		verwendungszweck: state => state.verwendungszweck,
		hinweis: state => state.hinweis,
		stateBIC: state => { 
			if(!state.bic) return null
			return validator.isBIC(state.bic)
		},
		stateVerwendungszweck: state => null,
		stateIBAN: state => { 
			if(!state.iban) return null
			//iban.electronicFormat(state.iban)
			return validator.isIBAN(state.iban)
		},
		stateBetrag: state => {
			if ( !state.betrag ) return false
			const value = new String(state.betrag)
			const floatValue = validator.toFloat(value)
			return validator.isDecimal(value, { locale: 'en-US' }) && 0.01 <= floatValue && 999999999.99 >= floatValue
			
		},
		stateReferenz: state => {
			if (!state.referenz) return null
			return validator.isLength(state.referenz, { max: 35})?null:false
		},
		stateReceipient: state => {
			if (!state.receipient) return null
			return validator.isLength(state.receipient, { max: 70})
		},
				
		contentOfQRCode: state => {
			const betrag = new Intl.NumberFormat('en-US', {useGrouping:false,  minimumFractionDigits: 2,  maximumFractionDigits: 2} ).format(state.betrag)
			const content =  [
				SERVICE_TAG,
				VERSION,
				CHARACTER_SET,
				IDENTIFICATION_CODE,
				state.bic.trim(), // todo: validate 8/11 chars
				state.receipient.trim(), // todo: validate <=70 chars
				iban.electronicFormat(state.iban),
				'EUR' + betrag,
				state.purposeCode || '',
				state.referenz.trim(),
				state.verwendungszweck.trim(),
				state.hinweis || ''
			].join('\n')
		return content
		}
		
	},
	mutations: {
		bic(state, payload) { state.bic = payload },
		receipient(state, payload) { state.receipient = payload },
		iban(state, payload) { state.iban = payload },
		betrag(state, payload) { state.betrag = payload },
		referenz(state, payload) { state.referenz = payload },
		verwendungszweck(state, payload) { state.verwendungszweck = payload },
		hinweis(state, payload) { state.hinweis = payload },
		undeleteTemplate(state, template) { state.undeleteTemplate = template },
		templates(state, payload) { state.templates = payload?[...payload]:[] }
  },
	actions: {
		test: (ctx) => console.log('coreState - action'),
		saveAsTemplate: ctx => {
			const templates = [...ctx.state.templates]
			const targetTemplateIndex = templates.findIndex( element => 
				iban.electronicFormat(element.iban) === iban.electronicFormat(ctx.state.iban))
			const element = {} 
			element.bic = ctx.getters.bic
			element.iban = ctx.getters.iban
			element.receipient = ctx.getters.receipient
			if(targetTemplateIndex >= 0)
				templates[targetTemplateIndex] = element
			else templates.push(element)
			ctx.commit('templates', templates)
		},
		deleteTemplate: (ctx, template) => {
			const templates = [...ctx.state.templates.filter( t => t.iban !== template.iban)]
			ctx.commit('undeleteTemplate', template)
			ctx.commit('templates', templates)

		},
		applyTemplate: (ctx, template) => {
			ctx.commit('iban', template.iban)
			ctx.commit('bic', template.bic)
			ctx.commit('receipient', template.receipient)
		},
		undelete: ctx => {
			const undeleteTemplate = ctx.state.undeleteTemplate
			const templates = [...ctx.state.templates]
			const targetTemplateIndex = templates.findIndex( element => 
				iban.electronicFormat(element.iban) === iban.electronicFormat(undeleteTemplate.iban))
			const element = undeleteTemplate
			if(targetTemplateIndex >= 0)
				templates[targetTemplateIndex] = element
			else templates.push(element)
			ctx.commit('templates', templates)
			ctx.commit('undeleteTemplate', null)
			
		},
		emptyTrash: ctx => {
			ctx.commit('undeleteTemplate', null)
		}
			
	}
}
const SERVICE_TAG = 'BCD'
const VERSION = '001'
const CHARACTER_SET = '2'
const IDENTIFICATION_CODE = 'SCT'

export default modulState
